import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'

import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'

import '@/assets/css/custom.css'
import '@/assets/css/custom-hyperion.css'
import '@/assets/css/fix-custom-hyperion.css'

Vue.config.productionTip = false

Vue.use(VueToast)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
